import { IntegrationDataResponse } from '@/ts/HococoInterfaces';
import { dateTimeFormatWithSeconds } from './DefaultTableConfigs';
import moment from 'moment';
import Vue from 'vue';

export default class IntegrationData {
    public static FromResponse(response: IntegrationDataResponse) {
        return new IntegrationData(
            response.id,
            response.corporationId,
            response.typeId,
            response.fileName,
            response.fileSize,
            response.guid,
            response.md5,
            response.mimeType,
            response.output,
            response.createdAt,
            response.updatedAt,
            response.deletedAt,
            response.runAt,
            response.disabledAt,
            response.processedAt,
            response.failedAt,
            response.lockedBy,
            response.runBy,
            response.providedBy,
        );
    }

    public id: number;
    public corporationId: number;
    public typeId: number;
    public filename: string;
    public filesize: string;
    public guid: string;
    public md5: string;
    public mimeType: string;
    public output: string;
    public createdAt: string;
    public updatedAt: string;
    public deletedAt?: string;
    public runAt?: string;
    public disabledAt: string;
    public processedAt: string;
    public failedAt: string;
    public lockedBy?: number;
    public runBy?: number;
    public providedBy: number;

    constructor(
        id: number,
        corporationId: number,
        typeId: number,
        filename: string,
        filesize: number,
        guid: string,
        md5: string,
        mimeType: string,
        output: string,
        createdAt: string,
        updatedAt: string,
        deletedAt: string,
        runAt: string,
        disabledAt: string,
        processedAt: string,
        failedAt: string,
        lockedBy: number,
        runBy: number,
        providedBy: number,
    ) {
        this.id            = id;
        this.corporationId = corporationId;
        this.typeId        = typeId;
        this.filename      = filename;
        this.filesize      = Vue.filter('bytesFormat')(filesize, 1);
        this.guid          = guid;
        this.md5           = md5;
        this.mimeType      = mimeType;
        this.output        = output;

        this.createdAt     = createdAt ? moment(createdAt).format(dateTimeFormatWithSeconds) : createdAt;
        this.updatedAt     = updatedAt ? moment(updatedAt).format(dateTimeFormatWithSeconds) : updatedAt;
        this.deletedAt     = deletedAt ? moment(deletedAt).format(dateTimeFormatWithSeconds) : deletedAt;

        this.disabledAt    = disabledAt ? moment(disabledAt).format(dateTimeFormatWithSeconds) : disabledAt;
        this.processedAt   = processedAt ? moment(processedAt).format(dateTimeFormatWithSeconds) : processedAt;
        this.failedAt      = failedAt ? moment(failedAt).format(dateTimeFormatWithSeconds) : failedAt;
        this.runAt         = runAt ? moment(runAt).format(dateTimeFormatWithSeconds) : runAt;

        this.lockedBy      = lockedBy;
        this.runBy         = runBy;
        this.providedBy    = providedBy;
    }

    public updateData(response: IntegrationDataResponse) {
        this.id            = response.id;
        this.corporationId = response.corporationId;
        this.typeId        = response.typeId;
        this.filename      = response.fileName;
        this.filesize      = Vue.filter('bytesFormat')(response.fileSize, 1);
        this.guid          = response.guid;
        this.md5           = response.md5;
        this.mimeType      = response.mimeType;
        this.output        = response.output;

        this.createdAt     = response.createdAt ? moment(response.createdAt).format(dateTimeFormatWithSeconds) : response.createdAt;
        this.updatedAt     = response.updatedAt ? moment(response.updatedAt).format(dateTimeFormatWithSeconds) : response.updatedAt;
        this.deletedAt     = response.deletedAt ? moment(response.deletedAt).format(dateTimeFormatWithSeconds) : response.deletedAt;

        this.disabledAt    = response.disabledAt ? moment(response.disabledAt).format(dateTimeFormatWithSeconds) : response.disabledAt;
        this.processedAt   = response.processedAt ? moment(response.processedAt).format(dateTimeFormatWithSeconds) : response.processedAt;
        this.failedAt      = response.failedAt ? moment(response.failedAt).format(dateTimeFormatWithSeconds) : response.failedAt;
        this.runAt         = response.runAt ? moment(response.runAt).format(dateTimeFormatWithSeconds) : response.runAt;

        this.lockedBy      = response.lockedBy;
        this.providedBy    = response.providedBy;
        this.runBy         = response.runBy;
    }

    get imported() {
        return (this.processedAt);
    }

    get disabled() {
        return (this.disabledAt) && !this.imported && !this.failedImport;
    }

    get readyForImport() {
        return (!this.runAt && !this.disabledAt && !this.failedAt && !this.processedAt);
    }

    get failedImport() {
        return (this.failedAt);
    }

    get processing() {
        return (this.runAt && !this.failedAt && !this.processedAt);
    }
}
